'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Callout } from '@/components/Callout'
import { CheckIcon } from './CheckIcon'
import { CrossIcon } from './CrossIcon'
import { Subheading } from '@/components/ui/subheading'
import { NonProfitModelBlock } from '@/payload-types'

export function NonProfitModelClient(props: NonProfitModelBlock) {
  return (
    <Section bgClassName="bg-rock-3">
      <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-x-[80px]">
        <div className="relative lg:top-[30px] lg:w-[300px]">
          <Callout heading={props.heading} content={props.description} variant="dark" />
        </div>
        <div className="lg:flex-1">
          <div className="bg-paper-1">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 bg-paper-1 p-[30px]">
              {props.positives.map((item, index) => (
                <div key={`positive-${index}`} className="flex flex-col gap-2">
                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center pt-[5px]">
                      <CheckIcon className="text-[#36D955]" />
                    </div>
                    <Subheading size="sm">{item.description}</Subheading>
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 bg-rock-1 p-[30px]">
              {props.negatives.map((item, index) => (
                <div key={`negative-${index}`} className="flex flex-col gap-2">
                  <div className="flex items-start gap-3">
                    <div className="flex items-center justify-center pt-[5px]">
                      <CrossIcon className="text-[#E50AAE]" />
                    </div>
                    <Subheading size="sm">{item.description}</Subheading>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}
